import { render } from "./ActualiteList.vue?vue&type=template&id=72907a63"
import script from "./ActualiteList.vue?vue&type=script&lang=js"
export * from "./ActualiteList.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__